import { SHORTLIST_LABELS } from "@constants/shortlist";

export const shortlistCardData = {
  labels: SHORTLIST_LABELS,
  iconPaths: {
    delete: "/icons/wishlist/DeleteIcon.svg",
    chevronRightBlue: "/icons/Chevron_right_blue.svg",
    editDark: "/icons/Edit_Pencil.svg",
    standardDelivery: "/icons/wishlist/Time.svg",
    expressDelivery: "/icons/wishlist/ExpressDelivery.svg",
    exclamation: "/icons/wishlist/Exclamation.svg",
    exclamationYellow: "/icons/wishlist/Exclamation-Yellow.svg",
    arrowRight: "/icons/Arrow_right_dark.svg",
    closeDark: "/icons/Close_Dark.svg",
    compareCars: "/icons/wishlist/CompareCars.svg",
    cardBg: "/icons/wishlist/ShortlistCardBackgroundImage.webp",
    ackoDriveLogo: "/icons/wishlist/AckoDriveLogo.svg",
  },
  iconSizes: {
    delete: { width: 32, height: 32 },
    chevron: { width: 16, height: 16 },
    edit: { width: 16, height: 16 },
    small: { width: 16, height: 16 },
    arrow: { width: 20, height: 20 },
    medium: { width: 24, height: 24 },
    standardDelivery: { width: 16, height: 16 },
    expressDelivery: { width: 16, height: 16 },
    ackoDriveLogo: { width: 32, height: 25 },
  },
} as const;
